import { inject, runInInjectionContext, EnvironmentInjector } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountService } from '../services/account.service';
import { KeycloakService } from '../services/keycloak.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, switchMap, of, take } from 'rxjs';

export const verifiedGuard: CanActivateFn = () => {
    const accountService = inject(AccountService);
    const keycloakService = inject(KeycloakService);
    const router = inject(Router);
    const injector = inject(EnvironmentInjector);

    return runInInjectionContext(injector, () =>
        toObservable(keycloakService.isReady).pipe(
            filter(isReady => isReady === true),
            take(1),
            switchMap(() => {
                const isVerified = accountService.isVerified();

                if (isVerified !== null) {
                    return of(isVerified ? true : router.createUrlTree(['/parametre']));
                }

                return runInInjectionContext(injector, () =>
                    toObservable(accountService.isVerified).pipe(
                        filter(v => v !== null),
                        take(1),
                        switchMap(verified => of(verified ? true : router.createUrlTree(['/parametre'])))
                    )
                );
            })
        )
    );
};